import { render, staticRenderFns } from "./OnetimePasswordReissue.vue?vue&type=template&id=35845f6a&scoped=true&"
import script from "./OnetimePasswordReissue.vue?vue&type=script&lang=js&"
export * from "./OnetimePasswordReissue.vue?vue&type=script&lang=js&"
import style0 from "./OnetimePasswordReissue.vue?vue&type=style&index=0&id=35845f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35845f6a",
  null
  
)

export default component.exports